import styles from "./index.module.scss";

export interface ModalForWelcomeProps {
  onClose: () => void;
  onLearn: () => void;
}

const ModalForWelcome = ({ onClose, onLearn }: ModalForWelcomeProps) => {
  return (
    <div className={styles.modalForWelcome}>
      <div className={styles.mask} onClick={onClose} />
      <div className={styles.main}>
        <div className={styles.action} onClick={onLearn} />
      </div>
    </div>
  );
};

export default ModalForWelcome;
